import { CurrencyCode } from '@noah-labs/shared-schema-gql';

export function isBTC(currencyCode: CurrencyCode | undefined): boolean {
  if (!currencyCode) {
    return false;
  }
  return [CurrencyCode.BTC, CurrencyCode.BTC_TEST].includes(currencyCode);
}
